import { render, staticRenderFns } from "./AfdRelogios.vue?vue&type=template&id=a2a4958e"
import script from "./AfdRelogios.vue?vue&type=script&lang=js"
export * from "./AfdRelogios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports